'use client';
import '@mux/mux-player/themes/news';
export default 'news';
